import React from "react";
import PageHeader from "../../components/PageHeader";
import EmailIcon from '@mui/icons-material/Email';
import ContactForm from "./ContactForm";
// import HubSpotForm from "./HubSpotForm";
const Contact = () =>{
    return(
        <>
            <PageHeader title="CONTACT US" description="Shoot us a message with your inquiries and we connect with you." />
            <div className="container-full-width border-top py-5">
                <div className="row">
                    <div className="col-md-6 mb-5">
                        <h2 style={{'fontWeight':'300'}}>LET'S WORK TOGETHER.</h2>
                        <p style={{'fontWeight':'300', 'fontSize':'24px'}} >We would love to discuss your next dream project with you.</p>

                        <br /><br />

                        <h2 style={{'fontWeight':'300'}}>Contact Emails.</h2>
                        <p  ><a href="mailto:info@toptechgiants.com" className="text-normal text-decoration-none">info@toptechgiants.com</a></p>
                        <p ><a   href="mailto:sudarshanhang@gmail.com" className="text-normal text-decoration-none">sudarshanhang@gmail.com</a></p>

                    </div>
                    <div className="col-md-6">
                       
                        <ContactForm />
                    </div>
                    

                </div>
             
            </div>
        </>

    );
}

export default Contact;
